(() => {
  'use strict';
  if (window.mgPriceRevealInitialized) return;
  window.mgPriceRevealInitialized = true;
  const element = document.getElementById('MgPriceRevealData');
  if (!element) return;
  const data = JSON.parse(element.textContent);
  const measurementId = 'G-CFYP1FEJYR';
  const experiment = 'home_price_reveal_v1';
  const qaRequested = new URLSearchParams(location.search).get('mg_qa') === '1';
  let ready = false, requesting = false, cohort, storageKey, homeSent = false;
  let timer, currentKey, visible = false;
  const sentPrices = new Set();
  const consent = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const log = message => { if (qaRequested || cohort?.qa) console.info('[MG QA] ' + message); };
  function send(name, parameters = {}) {
    if (!ready || !consent() || typeof window.gtag !== 'function') return false;
    const payload = {
      send_to: measurementId,
      experiment_version: experiment,
      entry_cohort: cohort.entry,
      home_exposed: cohort.exposed ? 'yes' : 'no',
      qa_traffic: cohort.qa ? 'yes' : 'no',
      ...parameters
    };
    if (cohort.qa) payload.debug_mode = true;
    window.gtag('event', name, payload);
    log(name + ' queued for existing GA4 tag; verify receipt in GA4.');
    return true;
  }
  function exposeHome() {
    if (data.pageType !== 'index' || homeSent || document.visibilityState !== 'visible') return;
    cohort.exposed = true;
    try { sessionStorage.setItem(storageKey, JSON.stringify(cohort)); } catch (_) {}
    homeSent = send('mg_home_view');
  }
  function selectedPrice() {
    const input = document.querySelector('[data-product-section] [name="id"]:checked') ||
      document.querySelector('[data-product-section] select[name="id"]');
    const variant = data.variants.find(item => item.id === input?.value);
    const price = document.querySelector('[data-product-price]');
    if (!variant || !price || price.textContent.trim() !== variant.formatted.trim()) return null;
    return { variant, price, key: variant.id + ':' + variant.price + ':' + data.currency };
  }
  function evaluatePrice() {
    clearTimeout(timer);
    if (!ready || !consent() || !visible || document.visibilityState !== 'visible') return;
    const selected = selectedPrice();
    if (!selected || sentPrices.has(selected.key)) return;
    currentKey = selected.key;
    timer = setTimeout(() => {
      const latest = selectedPrice();
      if (!latest || latest.key !== currentKey || !visible || document.visibilityState !== 'visible') return;
      const rect = latest.price.getBoundingClientRect();
      const area = Math.max(0, Math.min(rect.right, innerWidth) - Math.max(rect.left, 0)) *
        Math.max(0, Math.min(rect.bottom, innerHeight) - Math.max(rect.top, 0));
      if (rect.width * rect.height <= 0 || area / (rect.width * rect.height) < 0.5) return;
      if (send('mg_price_view', {product_type: data.productType === 'kit' ? 'complete_kit' : data.productType, selected_variant: latest.variant.id,
        displayed_price: latest.variant.price, currency: data.currency})) sentPrices.add(latest.key);
    }, 1000);
  }
  function connect() {
    if (ready || requesting || !consent() || typeof window.gtag !== 'function') return;
    requesting = true;
    window.gtag('get', measurementId, 'session_id', sessionId => {
      requesting = false;
      if (!sessionId || !consent()) { log('Existing GA4 session unavailable.'); return; }
      storageKey = experiment + ':' + sessionId;
      try { cohort = JSON.parse(sessionStorage.getItem(storageKey)); } catch (_) {}
      if (!cohort) cohort = { entry: data.pageType === 'index' ? 'homepage' : 'direct_product', exposed: false, qa: qaRequested };
      cohort.qa = cohort.qa || qaRequested;
      try { sessionStorage.setItem(storageKey, JSON.stringify(cohort)); } catch (_) {}
      ready = true;
      log('Existing GA4 session resolved.');
      exposeHome();
      evaluatePrice();
    });
    setTimeout(() => { if (!ready) log('No response from existing GA4 tag; diagnostic events not sent.'); }, 8000);
  }
  if (data.pageType === 'index') {
    document.addEventListener('click', event => {
      const link = event.target.closest('a[data-mg-shop]');
      if (!link || event.defaultPrevented || event.button !== 0) return;
      const url = new URL(link.href);
      if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) return;
      send('mg_shop_click', {destination_type: link.dataset.mgShop === 'kit' ? 'complete_kit' : 'refill', cta_location: link.dataset.mgCta === 'gateway' ? (link.dataset.mgShop === 'kit' ? 'kit_gateway' : 'refill_gateway') : link.dataset.mgCta});
    });
  } else {
    const price = document.querySelector('[data-product-price]');
    if (price) {
      new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
        evaluatePrice();
      }, {threshold: [0, 0.5, 1]}).observe(price);
      new MutationObserver(evaluatePrice).observe(price, {subtree:true, childList:true, characterData:true});
      document.querySelector('[data-product-section]')?.addEventListener('change', evaluatePrice);
    }
  }
  document.addEventListener('visibilitychange', () => { if (ready) exposeHome(); evaluatePrice(); });
  document.addEventListener('visitorConsentCollected', () => { connect(); evaluatePrice(); });
  log('Diagnostics loaded; checking existing consent and GA4 session.');
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (error) log('Shopify consent API failed to load; events remain blocked.');
      else connect();
    });
  }
  connect();
  setTimeout(() => {
    if (!consent()) log('Analytics consent is unavailable or denied; events remain blocked.');
  }, 10000);
  let attempts = 0;
  const check = setInterval(() => { connect(); if (ready || ++attempts >= 20) clearInterval(check); }, 500);
})();
